import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UserAddress } from "../../models/user-address-model";

const DeliveryAddress = (props: any) => {
  const { t } = useTranslation();
  const [userAddress, setUserAddress] = useState<UserAddress>(props.addressDetails);

  useEffect(() => {
    setUserAddress(props.addressDetails);
  }, [props.addressDetails]);

  const formatAddressLine = (parts: (string | undefined)[], separator = ', ') => {
    const validParts = parts.filter(part => part && part.trim() !== '');
    return validParts.join(separator);
  };

  const renderAddress = () => {
    if (!userAddress) return null;

    const addressLines = [
      formatAddressLine([userAddress.address1]),
      formatAddressLine([userAddress.address2]),
      formatAddressLine([userAddress.landmark]),
      formatAddressLine([
        userAddress.areaName,
        userAddress.subDisticName,
        userAddress.cityName
      ]),
      formatAddressLine([
        userAddress.stateName,
        userAddress.countryName,
        userAddress.zipcode ? `-${userAddress.zipcode}` : ''
      ], ' ')
    ].filter(line => line.trim() !== '');

    return (
      <>
        {addressLines.map((line, index) => (
          <p key={`address-line-${index}`} className="mb-0">
            {line}
            {index !== addressLines.length - 1 ? ',' : '.'}
          </p>
        ))}
      </>
    );
  };

  return (
    <>
      <h6 className="font-bold">{t("ordersummary_delivery_address")}</h6>
      {userAddress && renderAddress()}
      <h6 className="font-bold">
        {t("ordersummary_payment_mode")}: {props.paymentMode?.mode}
      </h6>
    </>
  );
};

export default DeliveryAddress;